module.exports = __webpack_public_path__ + "static/media/Aman.24f2c6f0.jpg";